import { apiClient } from "@base/api/client";
import {
  createImageZipJobResponseSchema,
  dailyLogImageZipFileResponseSchema,
  imageZipJobResponseSchema,
} from "./schemas";

export type ImageZipApiParams = {
  projectId: string;
  dailyLogId: string;
};

export type ImageZipJobApiParams = ImageZipApiParams & {
  jobId: string;
};

const getImageZipBasePath = ({ projectId, dailyLogId }: ImageZipApiParams) =>
  `/project-management/api/projects/${projectId}/daily-logs/${dailyLogId}/images/zip`;

export const downloadImagesApi = {
  async getImageZipFile(params: ImageZipApiParams) {
    const response = await apiClient.get(`${getImageZipBasePath(params)}/file`);
    return dailyLogImageZipFileResponseSchema.parse(response.data);
  },

  async createImageZipJob(params: ImageZipApiParams) {
    const response = await apiClient.post(getImageZipBasePath(params));
    return createImageZipJobResponseSchema.parse(response.data);
  },

  async getImageZipJob(params: ImageZipJobApiParams) {
    const response = await apiClient.get(getImageZipBasePath(params), {
      params: { job_id: params.jobId },
    });
    return imageZipJobResponseSchema.parse(response.data);
  },

  async cancelImageZipJob(params: ImageZipJobApiParams) {
    await apiClient.delete(getImageZipBasePath(params), {
      params: { job_id: params.jobId },
    });
  },
};
